import React from "react";
import { useDispatch } from "react-redux";
import { deletePartner } from "features/Promotion/promotionSlice";
import { formatPhoneNumber } from "utils/common";

const ListPartnerPromotion = ({
  openFn,
  list,
  promotionset_id,
  setPartnerInfo,
  partner_flg
}) => {
  const dispatch = useDispatch();

  // open modal update partner
  const handleUpdatePartner = (partner) => {
    setPartnerInfo(partner);
    openFn("modal-update-partner");
  };

  // handle delete partner
  const handleDeletePartner = (partner, promotionset_id) => {
    dispatch(deletePartner({ partner, promotionset_id }));
  };

  // get list partner fit promotion set
  const list_partner_id = list.filter((partner) =>
    partner.promotion_set_id.includes("" + promotionset_id)
  );

  return (
    <>
      <div  className={`${partner_flg === 1 ? 'bg-pink px-2 px-md-3 py-2': ''}`}>
        {partner_flg === 1 && (
          list_partner_id.length > 0 ? (
            list_partner_id.map((item, index) => (
              <div key={index} className="d-flex mb-2">
                <div className="fs-10 fs-sm-9 lh-21 mw-42">
                  同行者{index + 1} :
                </div>
                {/* INFOR OF PARTNER */}
                <div className="ms-2 ms-md-3">
                  <div className="fs-14">
                    {item.last_name + " " + item.first_name}
                  </div>
                  <div className="fs-12 fs-sm-9 text-grey">
                    <div>年齢：{item.age}</div>
                    <div>性別：{item.gender == 1 ? "男性" : "女性"}</div>
                    <div>電話番号：{formatPhoneNumber(item.phone)}</div>
                  </div>
                </div>
                <div className="ms-auto text-end mw-114">
                  {/* BUTTON UPDATE */}
                  <a onClick={() => handleUpdatePartner(item)} className="btn-box">
                    修正
                  </a>
                  {/* BUTTON DELETE */}
                  <a
                    onClick={() => handleDeletePartner(item, promotionset_id)}
                    className="btn-box ms-1 mt-1"
                  >
                    削除
                  </a>
                </div>
              </div>
            ))
          ) : (
            <div className="fs-10 fs-sm-9">同行者：なし</div>
          )
        )}
      </div>
    </>
  );
  
};

export default ListPartnerPromotion;
